module.exports = __webpack_public_path__ + "img/Nathan_Profile.26d10e03.jpg";